import {Frame} from "./Frame";
import useWave from "use-wave";
import {D} from "../../Constants";
import {Divider, Typography} from "@mui/material";
import {ChevronRight} from "@mui/icons-material";

interface Props {
  children: any;
  onClick?: () => void;
}

export const SectionTitle = (props: Props) => {
  const wave = useWave();

  return <Frame
    clickable={!!props.onClick}
    row
    clip
    ref={wave}
    height={D.interactive()}
    alignItems={'center'}
    padding={1}
    onClick={props.onClick}
  >
    <Typography variant="h5" unselectable={'on'} flexGrow={1}>
      {props.children}
    </Typography>
    {props.onClick && <ChevronRight/>}
    <Divider style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
    }}
    />
  </Frame>;
};